const ResetPasswordForm = () => {
  const buttonShowForm = document.querySelector('.jsShowPasswordResetForm')
  const loginForm = document.querySelector('.jsLoginForm')
  const passwordResetForm = document.querySelector('.jsResetPasswordForm')
  
  if (buttonShowForm && loginForm && passwordResetForm) {
    buttonShowForm.addEventListener('click', event => {
      event.preventDefault()
      loginForm.style.display = 'none'
      passwordResetForm.style.display = 'block'
    })
  }
}

export default ResetPasswordForm